import { motion } from "framer-motion";

export default function TourCard({ title, image, onClick }) {
    return (
        <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onClick}
            className="relative cursor-pointer rounded-2xl overflow-hidden shadow-lg"
        >
            {/* Background Image */}
            <img
                src={image}
                alt={title}
                className="w-full h-64 object-cover transition-transform duration-500 ease-in-out"
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center">
                <h3 className="text-white text-2xl font-bold text-center">{title}</h3>
            </div>
        </motion.div>
    );
}
